<template>
    <div class="settings">
        <!-- <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Standardwerte
                </p>
            </header>
            <div class="card-content">
                <div class="">
                    <b-field label="Absender - Mail-Adresse" horizontal>
                        <b-input></b-input>
                    </b-field>

                </div>
            </div>
        </div> -->
        <section>
            <b-collapse class="card" :open="false" aria-id="contentIdForPlaceholders" @close="saveAll()">
                <div slot="trigger" slot-scope="props" class="card-header" role="button"
                     aria-controls="contentIdForPlaceholders">
                    <p class="card-header-title">
                        Platzhalter
                    </p>
                    <a class="card-header-icon is primary">
                        <b-icon :icon="props.open ? 'save' : 'edit'" size="is-small">
                        </b-icon>
                    </a>
                </div>
                <div class="card-content">
                    <div class="content">
                        <div class="card" >
                            <div class="card-content">
                                <div class="content">
                                    <a class="card-header-icon" @click="$root.settings.placeholders.push({})">
                                        <b-icon icon="plus" pack="fal"></b-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="card" v-for="(p, index) in $root.settings.placeholders">
                            <div class="card-content">
                                <div class="content">
                                    <b-field label="Name" horizontal>
                                        <b-input v-model="p.name"></b-input>
                                        <p class="control">
                                            <b-button @click="$root.settings.placeholders.splice(index,1)">löschen</b-button>
                                        </p>
                                    </b-field>
                                    <b-field label="Code" horizontal>
                                        <b-input v-model="p.code"></b-input>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </section>
        <section>
            <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                        Firmierungen
                    </p>
                    <a class="card-header-icon" @click="addFirm()">
                        <b-icon icon="plus" pack="fal"></b-icon>
                    </a>
                </header>
                <div class="card-content">
                    <div class="">
                        <b-collapse class="card" :open="false" v-for="(firm, key) in $root.settings.firms"
                                    :aria-id="'contentIdForA'+firm.id" @close="parseHTML(firm)">
                            <div slot="trigger" slot-scope="props" class="card-header" role="button"
                                 :aria-controls="'contentIdForA'+firm.id">
                                <p class="card-header-title">
                                    #{{firm.id}}: {{firm.name}}
                                </p>
                                <a class="card-header-icon is primary">
                                    <b-icon :icon="props.open ? 'save' : 'edit'" size="is-small">
                                    </b-icon>
                                </a>
                            </div>
                            <div class="card-content">
                                <div class="content">
                                    <b-tabs v-model="$root.env.view.tabSettings" position="is-centered"
                                            type="is-toggle-rounded">
                                        <b-tab-item label="Allgemein" icon="cog">
                                            <b-field label="Bezeichnung" horizontal>
                                                <b-input v-model="firm.name"></b-input>
                                            </b-field>
                                            <b-field label="Redirect-URL" horizontal>
                                                <b-input expanded v-model="firm.url"
                                                         validation-message="Bitte geben Sie gültige URL ein"
                                                         pattern="(http)(s)?(:\/\/)[a-z0-9A-Z\.:-_]+(\/)?" required
                                                         @blur="checkURL(key)"></b-input>
                                            </b-field>
                                            <b-field horizontal>
                                                <template slot="label">
                                                    Fallback-URL
                                                    <b-tooltip type="is-light" label="Falls eine ungültige Landingpage aufgerufen wird, wird auf diese URL weitergeleitet">
                                                        <b-icon size="is-small" icon="question-circle"
                                                                pack="fal"></b-icon>
                                                    </b-tooltip>
                                                </template>
                                                <b-input expanded v-model="firm.fallbackUrl"
                                                         validation-message="Bitte geben Sie gültige URL ein"
                                                         pattern="(http)(s)?(:\/\/)[a-z0-9A-Z\.:-_]+(\/)?" required
                                                         @blur="checkFallbackURL(key)"></b-input>
                                            </b-field>
                                            <!--                                        <b-field label="Firmenname" horizontal>-->
                                            <!--                                            <b-input v-model="firm.title"></b-input>-->
                                            <!--                                        </b-field>-->
                                            <!--                                        <b-field label="Impressum" horizontal>-->
                                            <!--                                            <b-input maxlength="200" v-model="firm.imprint" type="textarea"></b-input>-->
                                            <!--                                        </b-field>-->
                                            <b-field label="Mailvorlage Dialog/Textmail" horizontal>
                                                <b-input v-model="firm.mailtemplate"
                                                         validation-message="Bitte geben Sie eine Zahl ein"
                                                         pattern="[1-9][0-9]*" required></b-input>
                                            </b-field>
                                            <b-field label="Mailvorlage Template (Kopiervorlage)" horizontal>
                                                <b-input v-model="firm.mailadvancedtemplate"
                                                         validation-message="Bitte geben Sie eine Zahl ein"
                                                         pattern="[1-9][0-9]*" required></b-input>
                                            </b-field>
                                            <b-field label="Favicon" horizontal>
                                                <b-input v-model="firm.favicon"></b-input>
                                                <p class="control">
                                                    <img :src="firm.favicon || 'https://shared.webapps.sendnode.com/events/favicon/android-chrome-192x192.png'"
                                                         style="max-height:30px">
                                                </p>
                                            </b-field>
                                            <b-field label="Sprache" horizontal grouped>
                                                <b-select placeholder="Bitte Sprache wählen" v-model="firm.lang">
                                                    <option value="de">Deutsch</option>
                                                    <option value="en">Englisch</option>
                                                </b-select>
                                            </b-field>
                                        </b-tab-item>
                                        <b-tab-item label="Landingpage" icon="code">
                                            <b-field label="HTML <head>" horizontal>
                                                <b-input maxlength="20000" v-model="firm.htmlHead" type="textarea"
                                                         custom-class="is-family-code is-size-7"
                                                         @blur="parseHTML(firm)"></b-input>
                                            </b-field>
                                            <b-field label="Header" horizontal>
                                                <b-input maxlength="20000" v-model="firm.htmlHeader" type="textarea"
                                                         custom-class="is-family-code is-size-7"
                                                         @blur="parseHTML(firm)"></b-input>
                                            </b-field>
                                            <b-field label="Footer" horizontal>
                                                <b-input maxlength="20000" v-model="firm.htmlFooter" type="textarea"
                                                         custom-class="is-family-code is-size-7"
                                                         @blur="parseHTML(firm)"></b-input>
                                            </b-field>
                                        </b-tab-item>
                                    </b-tabs>
                                    <hr>
                                    <div class="buttons">
                                        <b-button size="is-small" type="is-primary" icon-pack="fas" icon-left="copy"
                                                  @click="addFirm(firm)">
                                            Firmierung duplizieren
                                        </b-button>
                                        <b-button size="is-small" type="is-danger" icon-pack="fas" icon-left="trash-alt"
                                                  @click="removeFirm(key)">
                                            Firmierung Löschen
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'Settings',
        props: {
            msg: String
        },
        data() {
            return {
                here: ''
            }
        },
        methods: {
            checkURL(index) {
                let temp = this.$root.settings.firms[index]
                if (temp.url.slice(-1) != '/') {
                    temp.url += '/'
                }
                this.$root.settings.firms[index] = temp
            },
            checkFallbackURL(index) {
                let temp = this.$root.settings.firms[index]
                if (temp.fallbackUrl.slice(-1) != '/') {
                    temp.fallbackUrl += '/'
                }
                this.$root.settings.firms[index] = temp
            },
            split(str, separator, limit) {
                if (limit == 0) return [str];
                var a = str.split(separator, limit);
                if (a.length == limit) {
                    let s = a.join(separator) + separator;
                    a.push(str.substr(s.length));
                    return a;
                } else {
                    return [str];
                }
            },
            parseHTML(set) {
                let e = [
                    'htmlHead',
                    'htmlHeader',
                    'htmlFooter'
                ]
                let isGood = true
                let htmlInputs = []

                e.forEach(s => {
                    let results = set[s].matchAll(/\{\{\s*([^\}]*)\s*\}\}/gim);
                    for (let result of results) {
                        let proto = {}
                        let ok = true
                        let parts = this.split(result[1], ':', 3)

                        if (parts.length < 4) ok = false
                        if (ok) {
                            if (htmlInputs.filter(r => r.name == parts[1]).length == 0) {

                                proto.type = parts[0]
                                proto.name = parts[1]
                                proto.label = parts[2]
                                proto.default = parts[3]
                                htmlInputs.push(proto)
                            }
                        } else {
                            isGood = false
                        }
                    }

                })
                if (!isGood) {
                    this.$buefy.toast.open({
                        message: 'Fehler im HTML',
                        type: 'is-danger'
                    })
                } else {
                    set.htmlInputs = []
                    set.htmlInputs = htmlInputs
                    this.saveAll()
                }

            },
            saveAll() {
                this.$root.saveSettings(true)
            },
            addFirm(old = {}) {
                let firm = {}
                firm = Object.assign(firm, old)
                firm.id = ++this.$root.settings.counter.firms
                if (!firm.name) {
                    firm.name = 'Neue Firmierung'
                } else {
                    firm.name += ' Kopie'
                }
                this.$root.settings.firms.push(firm)
                this.$root.saveSettings()
            },
            removeFirm(index) {
                let old = this.$root.settings.firms[index]
                this.$buefy.dialog.confirm({
                    title: 'Firmierung löschen?',
                    message: 'Sind Sie sicher, dass Sie die <br>Firmierung <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                    confirmText: 'Firmierung löschen',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$root.settings.firms.splice(index, 1);
                        this.$root.saveSettings()
                        this.$buefy.toast.open({
                            message: 'Die Firmierung <b>' + old.name + '</b> wurde gelöscht',
                            type: 'is-success'
                        })
                    }
                })
            }
        },
        created() {
            if (!this.$root.settings.placeholders) {
                this.$root.settings.placeholders = []
            }
            if (!Array.isArray(this.$root.settings.placeholders)) {
                this.$root.settings.placeholders = []
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .card {
        display: block;
        width: 100%;
        margin-bottom: 1rem;
    }

    .input-tooltip {
        margin: auto 0;
    }
</style>
